import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { MotorDataDataService, MsdRequestData } from "src/app/share/data-service/motor.data.service";
import { ResetPasswordValidators } from "src/app/share/function/reset-password-validators";
import { FieldData } from "src/app/share/interface/common.interface";
import { IAvailableBanners } from "src/app/share/interface/motor.interface";
import { AlertService } from "src/app/share/service/alert.service";
import { AuthService } from "src/app/share/service/auth.service";
import { LoadingOverlayService } from "src/app/share/service/loading-overlay.service";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
	selector: "app-reset-password",
	templateUrl: "./reset-password.component.html",
	styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
	 hide: boolean = true;
	hideNew: boolean = true;
	expired: boolean = false;
	success: boolean = false;
	submitted: boolean = false;
	newPassLength: boolean = false;
	repeatNewPassLength: boolean = false;

	key_activation: any;
	resetPasswordFormGroup: FormGroup;
	partnerCode: string = 'ps';
	returnUrl: string = "";
  
    
  
  
    constructor(
      private activatedRoute: ActivatedRoute,
      private formBuilder: FormBuilder,
      private authService: AuthService,
      private loadingService: LoadingOverlayService,
      private motorDataDataService: MotorDataDataService,
      public alertService: AlertService,
      public router: Router,
      
  
    ) {
    }
  
    ngOnInit(): void {
      	this.resetPasswordFormGroup = new FormGroup(
			{
				newPassword: new FormControl(
					null,
					Validators.compose([
						Validators.required,
						Validators.minLength(8),
						ResetPasswordValidators.patternValidator(
							new RegExp("(?=.*[0-9])"),
							{
								requiresDigit: true,
							},
						),
						ResetPasswordValidators.patternValidator(
							new RegExp("(?=.*[a-z])"),
							{
								requiresLowercase: true,
							},
						),
						ResetPasswordValidators.patternValidator(
							new RegExp("(?=.*[$@^!%*?&])"),
							{
								requiresSpecialChars: true,
							},
						),
					]),
				),
				repeatNewPassword: new FormControl(null, [
					Validators.required,
					Validators.minLength(8),
				]),
			},
			{
				validators: ResetPasswordValidators.MatchValidator,
			},
		);;
    }
  
    
  
get f() {
		return this.resetPasswordFormGroup.controls;
	}

	get passwordValid() {
		return this.resetPasswordFormGroup.controls["newPassword"].errors === null;
	}

	get requiredValid() {
		return !this.resetPasswordFormGroup.controls["newPassword"].hasError(
			"required",
		);
	}

	get minLengthValid() {
		return !this.resetPasswordFormGroup.controls["newPassword"].hasError(
			"minlength",
		);
	}

	get requiresDigitValid() {
		return !this.resetPasswordFormGroup.controls["newPassword"].hasError(
			"requiresDigit",
		);
	}

	get requiresLowercaseValid() {
		return !this.resetPasswordFormGroup.controls["newPassword"].hasError(
			"requiresLowercase",
		);
	}

	get requiresSpecialCharsValid() {
		return !this.resetPasswordFormGroup.controls["newPassword"].hasError(
			"requiresSpecialChars",
		);
	}

	get isCarsome() {
		return this.partnerCode == 'carsome';
	}

	private errorDialog() {
		// this.dialog.open(InfoDialogComponent, {
		// 	width: "400px",
		// 	panelClass: "dialog-container",
		// 	data: {
		// 		img: "../../../assets/image/invalid-icon.png",
		// 		textBold: this.translate.instant("error.resetPassLinkInvalid"),
		// 	},
		// });
	}

	private successDialog() {
		// let dialogRef = this.dialog.open(InfoDialogComponent, {
		// 	width: "400px",
		// 	panelClass: "dialog-container",
		// 	data: {
		// 		img: "../../../assets/image/success-icon.png",
		// 		textBold: this.translate.instant("auth.successfullChange"),
		// 	},
		// });

		// dialogRef.afterClosed().subscribe((x) => {
		// 	// Navigate to login page
		// 	if(this.partnerCode == 'ps'){
		// 		this.router.navigate(["/login"]);
		// 	} else {
		// 		this.router.navigate(["/login"], { queryParams: { partnerCode: this.partnerCode } });
		// 	}
		// });
    window.location.href = "/affiliates?partnerCode=prolindung";

	}

	check_url_validation(key?: any) {
		this.motorDataDataService.resetPasswordLinkVerify(key).subscribe({
			next: (x) => {
				if (x) {
					this.expired = false;
				} else {
					this.expired = true;
				}
			},
			error: (err) => {
				this.errorDialog();
			},
		});
	}

	submit() {
		this.submitted = true;

		if (this.resetPasswordFormGroup.invalid) {
			return;
		}

		let new_password = this.resetPasswordFormGroup.get("newPassword").value;
		let confirmedNewPassword =
			this.resetPasswordFormGroup.get("repeatNewPassword").value;

		let encrypted_key = this.router.url.split('?key=')[1].split('&returnUrl')[0];

		let objRequest = {
			newPassword: new_password,
			confirmNewPassword: confirmedNewPassword,
			key: decodeURIComponent(encrypted_key),
		};

		this.loadingService.setLoading(true);
		this.motorDataDataService.resetPassword(objRequest).subscribe({
			next: (x) => {
				this.loadingService.setLoading(false);
				this.success = true;
				this.alertService.openSnackBar("Kata laluan anda telah berjaya dikemaskini. Sila log masuk menggunakan kata laluan baharu.");
				this.returnUrl = x;
        this.redirectToPage();
			},
			error: (err) => {
				this.loadingService.setLoading(false);
				this.errorDialog();
			},
		});
	}

	getNewPasswordLength(value: any) {
		if (value.length < 8) {
			this.newPassLength = false;
		} else {
			this.newPassLength = true;
		}
	}

	getRepeatNewPasswordLength(value: any) {
		if (value.length < 8) {
			this.repeatNewPassLength = false;
		} else {
			this.repeatNewPassLength = true;
		}
	}

	private redirectToPage() {
		this.router.navigate(['/login'], {
    queryParams: {
      returnUrl: this.activatedRoute.snapshot.queryParams.returnUrl,
      partnerCode: this.activatedRoute.snapshot.queryParams.partnerCode
    	}
		});
	}

	
}
